import PropTypes from "prop-types";
import React from "react";
import "./css/Cta.css";
import vector from "../assets/loginPage/Vector.svg";

/* This component is used to create a button. It is used on the login page. */

export const Cta = ({ text, className, onClick, style, onMouseEnter, onMouseLeave, type, disabled }) => {
    return (
        <button
            className={`CTA ${className}`}
            onClick={onClick}
            style={{
                ...(disabled ? { opacity: 0.6, cursor: "not-allowed" } : {}),
                ...style
            }}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            type={type}
            disabled={disabled}
        >
            <img className="vector" alt="Vector" src={vector} />
            <div className="join-the-community">{text || "SIGN IN"}</div>
        </button>
    );
};

Cta.propTypes = {
    text: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
    style: PropTypes.object,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    type: PropTypes.string,
    disabled: PropTypes.bool,
};
